// extracted by mini-css-extract-plugin
module.exports = {"rangeChart":"statisticTrendChart_rangeChart__vg5Jk"};